import React, { Fragment, useEffect, useState } from "react";
import cx from "classnames";

import { connect } from "react-redux";

import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import HeaderLogo from "../AppLogo";

import SearchBox from "./Components/SearchBox";
import MegaMenu from "./Components/MegaMenu";
import UserBox from "./Components/UserBox";
import {useMobileView} from "../../Components/utility/hooks";
import HeaderRightDrawer from "./Components/HeaderRightDrawer";

import HeaderDots from "./Components/HeaderDots";
import { get, map } from "lodash";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as configApi from "../../config/config_System";
import i18n from "../../i18n";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import languages from "../../config/languages";
import { Tooltip } from "antd";
function Header(props) {
  let { headerBackgroundColor, enableMobileMenuSmall, enableHeaderShadow } =
    props;
  const [selectedLang, setSelectedLang] = useState("");
  const [menu, setMenu] = useState(false);
  const isMobile = useMobileView();

  useEffect(() => {
    const currentLanguage = localStorage.getItem("I18N_LANGUAGE");
    setSelectedLang(currentLanguage);
  }, []);
  const changeLanguageAction = (lang) => {
    //set language as i18n
    i18n.changeLanguage(lang);
    localStorage.setItem("I18N_LANGUAGE", lang);
    setSelectedLang(lang);
    window.location.reload();
  };


  const toggle = () => {
    setMenu(!menu);
  };

  return (
    <Fragment>
      <CSSTransitionGroup
        component="div"
        className={cx("app-header", headerBackgroundColor, {
          "header-shadow": enableHeaderShadow,
        })}
        transitionName="HeaderAnimation"
        transitionAppear={true}
        transitionAppearTimeout={1500}
        transitionEnter={false}
        transitionLeave={false}
      >
        <HeaderLogo />
        <div
          className={cx("app-header__content", {
            "header-mobile-open": enableMobileMenuSmall,
          })}
        >
          <div className="app-header-right">
            {/* <HeaderDots /> */}
            <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block">
              <DropdownToggle className="btn header-item " tag="button">
                <img
                  src={get(languages, `${selectedLang}.flag`)}
                  alt="Skote"
                  height="16"
                  className="me-1"
                />
              </DropdownToggle>
              <DropdownMenu className="language-switch dropdown-menu-end">
                {map(Object.keys(languages), (key) => (
                  <DropdownItem
                    key={key}
                    onClick={() => changeLanguageAction(key)}
                    className={`notify-item ${
                      selectedLang === key ? "active" : "none"
                    }`}
                  >
                    <img
                      src={get(languages, `${key}.flag`)}
                      alt="Skote"
                      className="me-1"
                      height="12"
                    />
                    <span
                      className="align-middle"
                      style={{ paddingLeft: 10, paddingBottom: 4 }}
                    >
                      {get(languages, `${key}.label`)}
                    </span>
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
            <UserBox />
            {/* <HeaderRightDrawer /> */}
          </div>
        </div>
      </CSSTransitionGroup>
    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
  closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
  headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
